import {
  clickEvent,
  SellerBadgeType,
} from '@marketplace-web/seller-engagement-tools/seller-engagement-tools-data'

export enum SellerBadgeTranslationKey {
  FrequentUploads = 'frequent_uploads',
  QuickReplier = 'quick_replier',
  SpeedyShipping = 'speedy_shipping',
}

export enum ReplyTimeThreshold {
  VerySlow = 0,
  Slow = 24,
  Moderate = 12,
  Fast = 9,
  VeryFast = 6,
}

export enum QuickReplierProgress {
  VerySlow = 0,
  Slow = 0.25,
  Moderate = 0.5,
  Fast = 0.75,
  VeryFast = 1,
}

export enum SpeedyShippingProgress {
  None = 0,
  Quarter = 25,
  Half = 50,
  ThreeQuarters = 75,
  Full = 100,
}

export const MAP_BADGE_TYPE_TO_SCREEN = {
  [SellerBadgeType.ActiveLister]: 'lister_badge_info',
  [SellerBadgeType.FastReplier]: 'replier_badge_info',
}

export const MAP_BADGE_TYPE_TO_ACTION_TARGET = {
  [SellerBadgeType.ActiveLister]: 'upload_item',
  [SellerBadgeType.FastReplier]: 'check_inbox',
} satisfies Record<string, Parameters<typeof clickEvent>[0]['target']>

export const MAP_BADGE_TYPE_TO_BADGE_TARGET = {
  [SellerBadgeType.ActiveLister]: 'lister_badge',
  [SellerBadgeType.FastReplier]: 'replier_badge',
} satisfies Record<string, Parameters<typeof clickEvent>[0]['target']>
